import { useGetCmsTheme } from "@/api/cms";
import { PageTextColorField } from "@/components/cms/theme/PageTextColorField";
import {
  useCmsThemeEditorOnColorsChange,
  useCmsThemeEditorPalette,
} from "@/context/cms/CmsThemeEditorContext";
import { useCmsPageThemeForm } from "@/hooks/use-cms-page-theme-form";
import {
  findPaletteTextColorId,
  resolveColor,
} from "@/lib/cms/cms-theme.constants";

type Props = {
  formPrefix?: string;
};

export function CmsPageTextColorField({ formPrefix }: Props) {
  const palette = useCmsThemeEditorPalette();
  const onColorsChange = useCmsThemeEditorOnColorsChange();
  const { data: theme } = useGetCmsTheme();
  const { pageTextColorMode, pageTextColorId, setPageTheme } =
    useCmsPageThemeForm(formPrefix);
  const themeTextColorId = findPaletteTextColorId(palette);
  const resolvedThemeTextColorId =
    theme?.defaultPageTextColorId ?? themeTextColorId;
  const themePreviewHex = resolveColor(
    palette,
    resolvedThemeTextColorId,
    theme?.defaultPageTextColor ?? "#171717",
  );
  const themePreviewLabel =
    resolvedThemeTextColorId != null
      ? (() => {
          const color = palette.find(
            (entry) => entry.id === resolvedThemeTextColorId,
          );
          return color ? `${color.name} (${color.hex})` : undefined;
        })()
      : undefined;

  return (
    <PageTextColorField
      colors={palette}
      pageTextColorMode={pageTextColorMode}
      pageTextColorId={pageTextColorId}
      themePreviewHex={themePreviewHex}
      themePreviewLabel={themePreviewLabel}
      onModeChange={(pageTextColorMode) => {
        const patch =
          pageTextColorMode !== "CUSTOM"
            ? { pageTextColorMode, pageTextColorId: null }
            : {
                pageTextColorMode,
                pageTextColorId: pageTextColorId ?? palette[0]?.id ?? null,
              };
        setPageTheme(patch);
      }}
      onColorIdChange={(pageTextColorId) => setPageTheme({ pageTextColorId })}
      onColorsChange={onColorsChange}
    />
  );
}
